import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../services/language.service';

@Pipe({
    name: 'translateField',
    pure: false,
    standalone: false
})
export class TranslateFieldPipe implements PipeTransform {
  constructor(private languageService: LanguageService) {}

  transform(value: string): string {
    return this.languageService.getTranslatedFieldName(value);
  }
}
